// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WDW COLOR CODE */
/* AULANI COLOR CODE */
:host ::ng-deep .disney-checkbox__text {
  color: inherit !important;
}

:host ::ng-deep .disney-checkbox:hover .disney-checkbox__text {
  color: white;
}

.filter__search--input {
  background: white;
  font-size: 16px;
  display: flex;
  align-items: center;
  border: 1px solid #918F8C;
  border-radius: 4px;
}
.filter__search--input input {
  background: white;
  border: 0;
  height: 44px;
  width: 100%;
  font-family: "InspireTWDCBook";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.filter__search--input input:focus-visible {
  border: 0;
  outline: 0;
}
.filter__search--input:focus-within {
  outline: #00233c solid 1px;
}
.filter__search--input div {
  width: 32px;
  padding: 0 8px;
}
.filter__search--input div svg path {
  fill: #00233c;
}

.dropdown-container {
  display: flex;
  position: relative;
  font-family: "InspireTWDCBook";
  flex-direction: column;
}

.dropdown-container-error-border {
  margin-bottom: 5px;
}

.dropdown-section {
  cursor: pointer;
  background: #fff;
  border: 1px solid #918F8C;
  border-radius: 4px;
  min-height: 50px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 14px;
}
.dropdown-section .placeholder {
  padding-right: 10px;
  font-family: "InspireTWDCBook";
  font-weight: 400;
  font-size: 16px;
  color: #69645E;
}
.dropdown-section .placeholder.error-message {
  color: #AC162C;
}
.dropdown-section.no-bordered-view {
  border: none;
}

.error-border {
  border-bottom: 3px solid #AC162C !important;
}

.up-arrow {
  transform: rotate(180deg);
}

.arrow-container,
.selected-container {
  align-self: center;
}

.error-messages {
  display: flex;
  width: 100%;
  font-family: "InspireTWDCBook";
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  margin-top: 8px;
  color: #AC162C;
  line-height: 18px;
}
.error-messages .error-img {
  float: left;
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-right: 8px;
  color: #AC162C;
}

.selected-option-section {
  cursor: pointer;
  background: #fff;
  border: 1px solid #918F8C;
  border-radius: 4px;
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: space-between;
  padding: 4px 16px 6px;
  font-weight: normal;
  font-family: "InspireTWDCBook";
}
.selected-option-section.disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: #e6edef !important;
  color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170)) !important;
}
.selected-option-section.error {
  border-bottom: 3px solid #AC162C;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.selected-option-section .selected-container {
  padding-right: 10px;
}
.selected-option-section .title {
  font-size: 12px;
  color: #69645E;
  text-align: left;
}
.selected-option-section .title.error {
  color: #AC162C;
}
.selected-option-section .selected-option {
  font-size: 16px;
  text-align: left;
  color: #382613;
  font-weight: normal;
  font-family: "InspireTWDCBook";
}
.selected-option-section.no-bordered-view {
  border: none;
  padding: 0;
  justify-content: flex-start;
}
.selected-option-section.no-bordered-view .title {
  display: none;
}
.selected-option-section.no-bordered-view .selected-option span {
  color: #0079bc;
  font-size: 16px;
}

.menu-open {
  border-radius: 4px 4px 0 0;
}

.option-view {
  position: absolute;
  z-index: 20;
  top: 50px;
  text-align: left;
  width: 100%;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #918F8C;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 35vh;
}

.filter-wrapper {
  padding: 12px 16px;
  width: 100%;
}

.label-container {
  padding: 12px 16px;
  width: 100%;
  font-family: "InspireTWDCBook";
  font-weight: 400;
  font-size: 16px;
  color: #69645E;
}

.option-item {
  width: 100%;
  font-size: 16px;
  padding: 12px 16px;
  cursor: pointer;
  color: #382613;
  font-weight: normal;
  font-family: "InspireTWDCBook";
}
.option-item.disabled {
  pointer-events: none;
}
.option-item:hover, .option-item.selected {
  background-color: #0079bc;
  color: #fff;
}
.option-item:hover .item-value, .option-item.selected .item-value {
  color: #fff !important;
}
.option-item .option-label {
  margin: 0;
  font-size: 16px;
}
.option-item .checkbox-value {
  padding-left: 5px;
}
.option-item .item-value {
  padding: 0;
}
.option-item .item-value.with-label {
  color: #382613;
}

.option-view.no-bordered-view {
  border: 1px solid #c1cfd1;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.option-item.no-bordered-view {
  padding: 10px 12px;
}
.option-item.no-bordered-view:last-child {
  border-radius: 0 0 8px 8px;
}
.option-item.no-bordered-view:first-child {
  border-radius: 8px 8px 0 0;
}
.option-item.no-bordered-view:hover {
  background-color: #fff;
}
.option-item.no-bordered-view:hover .item-value {
  color: #0079bc;
}
.option-item.no-bordered-view.selected {
  background-color: #fff;
}
.option-item.no-bordered-view .item-value {
  color: #00233c;
  background-color: #fff;
}
.option-item.no-bordered-view .item-value:hover {
  text-decoration: underline;
}

.item-value.selected.no-bordered-view {
  color: #607682 !important;
}
.item-value.selected.no-bordered-view:hover {
  text-decoration: none !important;
}

.select-label.error {
  color: #AC162C !important;
}

:host ::ng-deep .cdk-virtual-scroll-viewport {
  contain: unset;
  overflow: auto;
}
:host ::ng-deep .cdk-virtual-scroll-viewport .cdk-virtual-scroll-content-wrapper {
  contain: unset;
}
:host ::ng-deep .cdk-virtual-scroll-viewport .option-item {
  font-family: "InspireTWDCBook";
  font-weight: 400;
}

.bordered-view {
  width: 100%;
  background: #fff;
}
.bordered-view input {
  width: 92%;
  font-family: "InspireTWDCBook";
  color: #382613;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 15px 5px 0 12px;
  outline: unset;
}
.bordered-view img {
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 18px;
  width: 16px;
}

span.close-icon {
  cursor: pointer;
  width: 24px;
  height: 24px;
  font-size: 20px;
  position: absolute;
  right: 10px;
  top: 12px;
}

.form-field {
  display: block;
}
.form-field--is-active .form-field__control:after {
  border-bottom: 2px solid #0079bc;
  transform: scaleX(150);
}
.form-field--is-active .form-field__label {
  color: #69645E;
}
.form-field--is-filled .form-field__label {
  top: 8px;
  font-size: 12px;
  transform: translateY(-16px);
}

.form-field__label {
  display: block;
  font-weight: normal;
  left: 0;
  margin: 0;
  padding: 13px 12px 0;
  color: #69645E;
  position: absolute;
  top: 0;
  transition: all 0.4s;
  width: 100%;
}
@media screen and (min-width: 834px) {
  .form-field__label {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
  }
}

.form-field__control {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 50px;
  text-align: left;
  border: 1px solid #918F8C;
}
.form-field__control:after {
  border-bottom: 3px solid #918F8C;
  bottom: 0;
  content: "";
  display: block;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  transform: scaleX(0);
  transition: all 0.4s;
  width: 1%;
}
.form-field__control.menu-open {
  border-radius: 4px 4px 0 0;
}
.form-field__control.error {
  border-bottom: 3px solid #AC162C;
}
.form-field__control.error-after:after {
  border-bottom: 3px solid #AC162C !important;
}

.form-field__input {
  -webkit-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  color: #00233c;
  height: 50px;
  display: block;
  font-size: 1.2rem;
  outline: 0;
  width: 100%;
}
@media screen and (min-width: 834px) {
  .form-field__input {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
  }
}

.disabled {
  background-color: #e6edef;
}
.disabled .form-field__label {
  color: #00233c;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/theme/index.scss","webpack://./src/app/shared/components/disney-dropdown/disney-dropdown.component.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/assets/style/base/colors.scss"],"names":[],"mappings":"AAAA,mBAAA;AAkBA,sBAAA;ACdA;EACI,yBAAA;AADJ;;AAKI;EACI,YAAA;AAFR;;AAMA;EACI,iBAAA;EAiBA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAnBJ;AAAI;EACI,iBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,8BCrBgB;EDsBhB,eAAA;EACA,gBAAA;EACA,iBAAA;AAER;AAAQ;EACI,SAAA;EACA,UAAA;AAEZ;AAOI;EACI,0BAAA;AALR;AAQI;EACI,WAAA;EACA,cAAA;AANR;AAQQ;EACI,aEsBE;AF5Bd;;AAWA;EACI,aAAA;EACA,kBAAA;EACA,8BCtDoB;EDuDpB,sBAAA;AARJ;;AAWA;EACI,kBAAA;AARJ;;AAWA;EACI,eAAA;EACA,gBE7DyB;EF8DzB,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;AARJ;AAUI;EACI,mBAAA;EACA,8BC3EgB;ED4EhB,gBAAA;EACA,eAAA;EACA,cDlDiB;AC0CzB;AAUQ;EACI,cEVM;AFElB;AAYI;EACI,YAAA;AAVR;;AAcA;EACI,2CAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;;EAEI,kBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,WAAA;EACA,8BC1GoB;ED2GpB,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cExCc;EFyCd,iBAAA;AAXJ;AAaI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cEjDU;AFsClB;;AAeA;EACI,eAAA;EACA,gBE3HyB;EF4HzB,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BCvIoB;AD2HxB;AAcI;EACI,mBAAA;EACA,oBAAA;EACA,oCAAA;EACA,iEAAA;AAZR;AAeI;EACI,gCAAA;EACA,4BAAA;EACA,6BAAA;AAbR;AAgBI;EACI,mBAAA;AAdR;AAiBI;EACI,eAAA;EACA,cDhIiB;ECiIjB,gBAAA;AAfR;AAiBQ;EACI,cEzFM;AF0ElB;AAmBI;EACI,eAAA;EACA,gBAAA;EACA,cD5IoB;EC6IpB,mBAAA;EACA,8BCzKgB;ADwJxB;AAoBI;EACI,YAAA;EACA,UAAA;EACA,2BAAA;AAlBR;AAoBQ;EACI,aAAA;AAlBZ;AAqBQ;EACI,cEvHD;EFwHC,eAAA;AAnBZ;;AAwBA;EACI,0BAAA;AArBJ;;AAwBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBEpMyB;EFqMzB,yBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AArBJ;;AAwBA;EACI,kBAAA;EACA,WAAA;AArBJ;;AAwBA;EACI,kBAAA;EACA,WAAA;EACA,8BCtNoB;EDuNpB,gBAAA;EACA,eAAA;EACA,cD7LqB;ACwKzB;;AAwBA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cDtMwB;ECuMxB,mBAAA;EACA,8BCnOoB;AD8MxB;AAuBI;EACI,oBAAA;AArBR;AAwBI;EAEI,yBE5KG;EF6KH,WEzOqB;AFkN7B;AAyBQ;EACI,sBAAA;AAvBZ;AA2BI;EACI,SAAA;EACA,eAAA;AAzBR;AA4BI;EACI,iBAAA;AA1BR;AA6BI;EACI,UAAA;AA3BR;AA6BQ;EACI,cDrOgB;AC0M5B;;AAgCA;EACI,yBAAA;EACA,0CAAA;EACA,kBAAA;AA7BJ;;AAgCA;EACI,kBAAA;AA7BJ;AA+BI;EACI,0BAAA;AA7BR;AAgCI;EACI,0BAAA;AA9BR;AAiCI;EACI,sBEpRqB;AFqP7B;AAiCQ;EACI,cE3ND;AF4LX;AAmCI;EACI,sBE5RqB;AF2P7B;AAoCI;EACI,cE/NM;EFgON,sBEjSqB;AF+P7B;AAoCQ;EACI,0BAAA;AAlCZ;;AAwCI;EACI,yBAAA;AArCR;AAuCQ;EACI,gCAAA;AArCZ;;AA2CI;EACI,yBAAA;AAxCR;;AA4CA;EACI,cAAA;EACA,cAAA;AAzCJ;AA2CI;EACI,cAAA;AAzCR;AA4CI;EACI,8BCrUgB;EDsUhB,gBAAA;AA1CR;;AAkDA;EACI,WAAA;EACA,gBE7UyB;AF8R7B;AAiDI;EACI,UAAA;EACA,8BCpVgB;EDqVhB,cD1ToB;EC2TpB,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AA/CR;AAkDI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAhDR;;AAoDA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAjDJ;;AA4DA;EACI,cAAA;AAzDJ;AA6DY;EACI,gCAAA;EACA,sBAAA;AA3DhB;AA+DQ;EACI,cDzWa;AC4SzB;AAkEQ;EACI,QAAA;EAtBR,eAAA;EACA,4BAAA;AAzCJ;;AAqEA;EACI,cAAA;EACA,mBAAA;EACA,OAAA;EACA,SAAA;EACA,oBAAA;EACA,cD5XqB;EC6XrB,kBAAA;EACA,MAAA;EACA,oBAAA;EACA,WAAA;AAlEJ;AAoEI;EAZJ;IAaQ,mBAAA;IACA,gBAAA;IACA,qBAAA;IACA,uBAAA;EAjEN;AACF;;AAoEA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AAjEJ;AAmEI;EACI,gCAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oBAAA;EACA,SAAA;AAjER;AAoEI;EACI,0BAAA;AAlER;AAqEI;EACI,gCAAA;AAnER;AAuEQ;EACI,2CAAA;AArEZ;;AA0EA;EACI,wBAAA;UAAA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,cE5YU;EF6YV,YAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AAvEJ;AAyEI;EAXJ;IAYQ,mBAAA;IACA,gBAAA;IACA,qBAAA;IACA,uBAAA;EAtEN;AACF;;AAyEA;EACI,yBApJQ;AA8EZ;AAwEI;EACI,cE/ZM;AFyVd","sourcesContent":["/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","@import '../../../../assets/style/base/colors';\r\n@import '../../../../assets/style/base/font';\r\n@import '../../../../assets/style/theme/index';\r\n\r\n:host ::ng-deep .disney-checkbox__text {\r\n    color: inherit !important;\r\n}\r\n\r\n:host ::ng-deep .disney-checkbox:hover {\r\n    .disney-checkbox__text {\r\n        color: white;\r\n    }\r\n}\r\n\r\n.filter__search--input {\r\n    background: white;\r\n\r\n    input {\r\n        background: white;\r\n        border: 0;\r\n        height: 44px;\r\n        width: 100%;\r\n        font-family: $inspiretwdc-book-font;\r\n        font-size: 16px;\r\n        font-weight: 400;\r\n        line-height: 24px;\r\n\r\n        &:focus-visible {\r\n            border: 0;\r\n            outline: 0;\r\n        }\r\n    }\r\n    font-size: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    border: 1px solid $input-border-color;\r\n    border-radius: 4px;\r\n\r\n    &:focus-within {\r\n        outline: $slate-color solid 1px;\r\n    }\r\n\r\n    div {\r\n        width: 32px;\r\n        padding: 0 8px;\r\n\r\n        svg path {\r\n            fill: $slate-color;\r\n        }\r\n    }\r\n}\r\n\r\n.dropdown-container {\r\n    display: flex;\r\n    position: relative;\r\n    font-family: $inspiretwdc-book-font;\r\n    flex-direction: column;\r\n}\r\n\r\n.dropdown-container-error-border {\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.dropdown-section {\r\n    cursor: pointer;\r\n    background: $kng-color-white;\r\n    border: 1px solid $input-border-color;\r\n    border-radius: 4px;\r\n    min-height: 50px;\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    padding: 14px;\r\n\r\n    .placeholder {\r\n        padding-right: 10px;\r\n        font-family: $inspiretwdc-book-font;\r\n        font-weight: 400;\r\n        font-size: 16px;\r\n        color: $aulani-warm-grey-color;\r\n\r\n        &.error-message {\r\n            color: $error-red-color;\r\n        }\r\n    }\r\n\r\n    &.no-bordered-view {\r\n        border: none;\r\n    }\r\n}\r\n\r\n.error-border {\r\n    border-bottom: 3px solid $error-red-color !important;\r\n}\r\n\r\n.up-arrow {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.arrow-container,\r\n.selected-container {\r\n    align-self: center;\r\n}\r\n\r\n.error-messages {\r\n    display: flex;\r\n    width: 100%;\r\n    font-family: $inspiretwdc-book-font;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    text-align: left;\r\n    margin-top: 8px;\r\n    color: $error-red-color;\r\n    line-height: 18px;\r\n\r\n    .error-img {\r\n        float: left;\r\n        width: 16px;\r\n        height: 16px;\r\n        font-size: 16px;\r\n        margin-right: 8px;\r\n        color: $error-red-color;\r\n    }\r\n}\r\n\r\n.selected-option-section {\r\n    cursor: pointer;\r\n    background: $kng-color-white;\r\n    border: 1px solid $input-border-color;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 50px;\r\n    justify-content: space-between;\r\n    padding: 4px 16px 6px;\r\n    font-weight: normal;\r\n    font-family: $inspiretwdc-book-font;\r\n\r\n    &.disabled {\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n        background-color: $cool-grey-100 !important;\r\n        color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170)) !important;\r\n    }\r\n\r\n    &.error {\r\n        border-bottom: 3px solid $error-red-color;\r\n        border-bottom-left-radius: 0;\r\n        border-bottom-right-radius: 0;\r\n    }\r\n\r\n    .selected-container {\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .title {\r\n        font-size: 12px;\r\n        color: $aulani-warm-grey-color;\r\n        text-align: left;\r\n\r\n        &.error {\r\n            color: $error-red-color;\r\n        }\r\n    }\r\n\r\n    .selected-option {\r\n        font-size: 16px;\r\n        text-align: left;\r\n        color: $aulani-primary-text-color;\r\n        font-weight: normal;\r\n        font-family: $inspiretwdc-book-font;\r\n    }\r\n\r\n    &.no-bordered-view {\r\n        border: none;\r\n        padding: 0;\r\n        justify-content: flex-start;\r\n\r\n        .title {\r\n            display: none;\r\n        }\r\n\r\n        .selected-option span {\r\n            color: $blue-700;\r\n            font-size: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.menu-open {\r\n    border-radius: 4px 4px 0 0;\r\n}\r\n\r\n.option-view {\r\n    position: absolute;\r\n    z-index: 20;\r\n    top: 50px;\r\n    text-align: left;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n    background-color: $kng-color-white;\r\n    border: 1px solid $input-border-color;\r\n    border-top: none;\r\n    border-radius: 0 0 4px 4px;\r\n    max-height: 35vh;\r\n}\r\n\r\n.filter-wrapper {\r\n    padding: 12px 16px;\r\n    width: 100%;\r\n}\r\n\r\n.label-container {\r\n    padding: 12px 16px;\r\n    width: 100%;\r\n    font-family: $inspiretwdc-book-font;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    color: $aulani-warm-grey-color;\r\n}\r\n\r\n.option-item {\r\n    width: 100%;\r\n    font-size: 16px;\r\n    padding: 12px 16px;\r\n    cursor: pointer;\r\n    color: $aulani-primary-text-color;\r\n    font-weight: normal;\r\n    font-family: $inspiretwdc-book-font;\r\n\r\n    &.disabled {\r\n        pointer-events: none;\r\n    }\r\n\r\n    &:hover,\r\n    &.selected {\r\n        background-color: $blue-700;\r\n        color: $kng-color-white;\r\n\r\n        .item-value {\r\n            color: $kng-color-white !important;\r\n        }\r\n    }\r\n\r\n    .option-label {\r\n        margin: 0;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .checkbox-value {\r\n        padding-left: 5px;\r\n    }\r\n\r\n    .item-value {\r\n        padding: 0;\r\n\r\n        &.with-label {\r\n            color: $aulani-primary-text-color;\r\n        }\r\n    }\r\n}\r\n\r\n.option-view.no-bordered-view {\r\n    border: 1px solid $horizontal-line-gray;\r\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\r\n    border-radius: 8px;\r\n}\r\n\r\n.option-item.no-bordered-view {\r\n    padding: 10px 12px;\r\n\r\n    &:last-child {\r\n        border-radius: 0 0 8px 8px;\r\n    }\r\n\r\n    &:first-child {\r\n        border-radius: 8px 8px 0 0;\r\n    }\r\n\r\n    &:hover {\r\n        background-color: $kng-color-white;\r\n\r\n        .item-value {\r\n            color: $blue-700;\r\n        }\r\n    }\r\n\r\n    &.selected {\r\n        background-color: $kng-color-white;\r\n    }\r\n\r\n    .item-value {\r\n        color: $slate-color;\r\n        background-color: $kng-color-white;\r\n\r\n        &:hover {\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}\r\n\r\n.item-value {\r\n    &.selected.no-bordered-view {\r\n        color: $light-black-grey !important;\r\n\r\n        &:hover {\r\n            text-decoration: none !important;\r\n        }\r\n    }\r\n}\r\n\r\n.select-label {\r\n    &.error {\r\n        color: $error-red-color !important;\r\n    }\r\n}\r\n\r\n:host ::ng-deep .cdk-virtual-scroll-viewport {\r\n    contain: unset;\r\n    overflow: auto;\r\n\r\n    .cdk-virtual-scroll-content-wrapper {\r\n        contain: unset;\r\n    }\r\n\r\n    .option-item {\r\n        font-family: $inspiretwdc-book-font;\r\n        font-weight: 400;\r\n    }\r\n}\r\n\r\n// Searchable Inputs\r\n$slate-900: #00233c;\r\n$cool-grey: #e6edef;\r\n\r\n.bordered-view {\r\n    width: 100%;\r\n    background: $kng-color-white;\r\n\r\n    input {\r\n        width: 92%;\r\n        font-family: $inspiretwdc-book-font;\r\n        color: $aulani-primary-text-color;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        font-size: 16px;\r\n        line-height: 16px;\r\n        padding: 15px 5px 0 12px;\r\n        outline: unset;\r\n    }\r\n\r\n    img {\r\n        position: absolute;\r\n        cursor: pointer;\r\n        right: 10px;\r\n        top: 18px;\r\n        width: 16px;\r\n    }\r\n}\r\n\r\nspan.close-icon {\r\n    cursor: pointer;\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 20px;\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 12px;\r\n}\r\n\r\n// Floating input styles\r\n$animation-duration: 0.4s;\r\n\r\n@mixin label-active() {\r\n    font-size: 12px;\r\n    transform: translateY(-16px);\r\n}\r\n\r\n.form-field {\r\n    display: block;\r\n\r\n    &--is-active {\r\n        .form-field__control {\r\n            &:after {\r\n                border-bottom: 2px solid $blue-700;\r\n                transform: scaleX(150);\r\n            }\r\n        }\r\n\r\n        .form-field__label {\r\n            color: $aulani-warm-grey-color;\r\n        }\r\n    }\r\n\r\n    &--is-filled {\r\n        .form-field__label {\r\n            top: 8px;\r\n\r\n            @include label-active();\r\n        }\r\n    }\r\n}\r\n\r\n.form-field__label {\r\n    display: block;\r\n    font-weight: normal;\r\n    left: 0;\r\n    margin: 0;\r\n    padding: 13px 12px 0;\r\n    color: $aulani-warm-grey-color;\r\n    position: absolute;\r\n    top: 0;\r\n    transition: all 0.4s;\r\n    width: 100%;\r\n\r\n    @media screen and (min-width: 834px) {\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        display: inline-block;\r\n        text-overflow: ellipsis;\r\n    }\r\n}\r\n\r\n.form-field__control {\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50px;\r\n    text-align: left;\r\n    border: 1px solid $input-border-color;\r\n\r\n    &:after {\r\n        border-bottom: 3px solid $input-border-color;\r\n        bottom: 0;\r\n        content: '';\r\n        display: block;\r\n        left: 0;\r\n        margin: 0 auto;\r\n        position: absolute;\r\n        right: 0;\r\n        transform: scaleX(0);\r\n        transition: all $animation-duration;\r\n        width: 1%;\r\n    }\r\n\r\n    &.menu-open {\r\n        border-radius: 4px 4px 0 0;\r\n    }\r\n\r\n    &.error {\r\n        border-bottom: 3px solid $error-red-color ;\r\n    }\r\n\r\n    &.error-after {\r\n        &:after {\r\n            border-bottom: 3px solid $error-red-color  !important;\r\n        }\r\n    }\r\n}\r\n\r\n.form-field__input {\r\n    appearance: none;\r\n    background: transparent;\r\n    border: 0;\r\n    color: $slate-color;\r\n    height: 50px;\r\n    display: block;\r\n    font-size: 1.2rem;\r\n    outline: 0;\r\n    width: 100%;\r\n\r\n    @media screen and (min-width: 834px) {\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        display: inline-block;\r\n        text-overflow: ellipsis;\r\n    }\r\n}\r\n\r\n.disabled {\r\n    background-color: $cool-grey;\r\n\r\n    .form-field__label {\r\n        color: $slate-color;\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","// Prefix kng-color to be added for above\r\n// ------------------------------------\r\n// Kingswell Named Colors\r\n// ------------------------------------\r\n$kng-color-white:            #fff;\r\n$kng-color-light-blue:       #ebf6fc;\r\n$kng-color-primary-blue:     #41a7e1;\r\n$kng-color-medium-blue:      #1483bd;\r\n$kng-color-active-dark-blue: #253b56;\r\n$kng-color-inactive-grey:    #a1afc0;\r\n$kng-color-messaging-grey:   #8294aa;\r\n$kng-color-active-grey:      #65778a;\r\n$kng-color-workspace-grey:   #f2f2f2;\r\n$kng-color-medium-grey:      #d9d9d9;\r\n$kng-color-disable-grey:     #e6e2e2;\r\n$kng-color-light-gray:       #f6f5fa;\r\n$kng-color-feather-gray:     #d5d5e0;\r\n$kng-color-charcoal-gray:    #6a7889;\r\n$kng-color-royal-blue:       #0f6fdc;\r\n$kng--color-sunrise-orange:  #e42b0a;\r\n$kng-color-slate-grey:       #8596aa;\r\n$kng-color-sky-blue:         #ebf4fc;\r\n\r\n$kng-color-light-yellow:     #fcf8e3;\r\n$kng-color-dark-yellow:      #c09853;\r\n$kng-color-green:            #6fa623;\r\n$kng-color-alert-orange:     #f63;\r\n$kng-color-primary-green:    #7cb130;\r\n$kng-color-secondary-green:  #008820;\r\n\r\n$kng-color-magic-kingdom:    #1994d7;\r\n$kng-color-water-parks:      #009eb2;\r\n$kng-color-animal-kingdom:   #628d25;\r\n$kng-color-epcot:            #d0662c;\r\n$kng-color-hollywood-studios:#6f46ad;\r\n$kng-color-other-property:   #6f46ad;\r\n$kng-color-black:            #000;\r\n\r\n$kng-color-other-properties-dark-blue: #0a4999;\r\n$kng-color-overlay-background: rgba(0, 0, 0, 0.6);\r\n$kng-color-overlay-background-light: rgba(17, 77, 151, 0.8);\r\n$kng-card-shadow: rgba(37, 59, 86, 0.35);\r\n\r\n// Custom color for DVC SI\r\n$kng-color-primary-workspace-disabled: #bcbcbc;\r\n$kng-color-primary-hover: #8dc74c;\r\n$kng-color-primary-pressed: #5a8822;\r\n$kng-color-secondary-pressed-gray: #f9f9f9;\r\n\r\n$vp-color-medium-blue: #114d97;\r\n$vp-color-green: #00993e;\r\n$vp-color-green-active: #0f6e17;\r\n$vp-color-light-blue: #4171ac;\r\n$wdpr-button-bg: rgba(255, 255, 255, 0.95);\r\n\r\n$kng-color-blue-medium: #0079bc;\r\n$kng-color-dark-grey: #00233c;\r\n$kng-color-black-light:       #888;\r\n$kng-color-black-text:       #555;\r\n\r\n$blue-900: #083c5d;\r\n$blue-000: #f3fdff;\r\n$blue-200: #acd4e7;\r\n$blue-300: #b7e4f7;\r\n$blue-700: #0079bc;\r\n$blue-800: #006096;\r\n$blue-900: #083c5d;\r\n$light-blue: #cee6f2;\r\n\r\n$slate-color: #00233c;\r\n$input-border-color: #918F8C;\r\n$light-black-grey: #607682;\r\n$error-red-color: #AC162C;\r\n$horizontal-line-gray: #c1cfd1;\r\n$horizontal-line-light-gray: #e6edef;\r\n$light-grey-border: #c1cfd1;\r\n$checkbox-select: #008900;\r\n$border-success-color: #61941B;\r\n\r\n$slate-000: #f5fbfc;\r\n$slate-100: #e1eef4;\r\n$slate-200: #cee6f2;\r\n$slate-300: #acd4e7;\r\n$slate-400: #83b0cf;\r\n$slate-500: #6591b5;\r\n$slate-600: #4d79a0;\r\n$slate-700: #35618d;\r\n$slate-800: #063f69;\r\n$slate-900: #00233c;\r\n\r\n$cool-grey-000: #f7fbfc;\r\n$cool-grey-100: #e6edef;\r\n$cool-grey-200: #d3dee2;\r\n$cool-grey-300: #c1cfd1;\r\n$cool-grey-400: #acbac1;\r\n$cool-grey-500: #8fa1aa;\r\n$cool-grey-600: #798e99;\r\n$cool-grey-700: #607682;\r\n$cool-grey-800: #445763;\r\n$cool-grey-900: #2c353d;\r\n\r\n$orange-000: #fff9f8;\r\n$orange-100: #ffeeeb;\r\n$orange-200: #ffe3dc;\r\n$orange-300: #ffcab8;\r\n$orange-400: #ffb199;\r\n$orange-500: #ff8a66;\r\n$orange-600: #ee6034;\r\n$orange-700: #dd3700;\r\n$orange-800: #a82502;\r\n$orange-900: #821c00;\r\n\r\n$checkbox-select: #008900;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
